/* eslint-disable no-console */
import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import {
  HeaderText,
  DropdownMaterial,
  MultipleChoice,
  SingleChoice
} from '@splunk-iteng/splunk-shared-components'

const PREVIEW_STORAGE_KEY = 'abacPreviewState'

type AppAttribute = {
  app_name: string
  attribute_order: number
  attribute_key: string
  attribute_value: string
  attribute_type: string
  attribute_is_required: boolean
  attribute_is_published: boolean
}

export function ABACPreviewer() {
  const [searchParams] = useSearchParams()
  const [appAttribute, setAppAttribute] = useState<AppAttribute[]>([])

  useEffect(() => {
    const queryAppName = searchParams.get('AppName') ?? ''

    if (globalThis.window === undefined) {
      setAppAttribute([])
      return
    }

    const serializedPreviewState =
      globalThis.window.localStorage.getItem(PREVIEW_STORAGE_KEY)

    if (!serializedPreviewState) {
      setAppAttribute([])
      return
    }

    try {
      const parsedPreviewState = JSON.parse(serializedPreviewState) as {
        appName?: string
        appAttribute?: AppAttribute[]
      }
      const savedAttributes = Array.isArray(parsedPreviewState.appAttribute)
        ? parsedPreviewState.appAttribute
        : []

      if (!queryAppName) {
        setAppAttribute(savedAttributes)
        return
      }

      if (parsedPreviewState.appName === queryAppName) {
        setAppAttribute(savedAttributes)
        return
      }

      setAppAttribute(
        savedAttributes.filter((item) => item.app_name === queryAppName)
      )
    } catch (error) {
      console.error('Unable to parse ABAC preview state', error)
      setAppAttribute([])
    }
  }, [searchParams])

  const preventEnter = async (e: React.FormEvent) => {
    e.preventDefault()
  }

  return (
    <form onSubmit={preventEnter}>
      {appAttribute.length <= 0 ? (
        <div>Nothing to preview</div>
      ) : (
        <div>
          {appAttribute.map((item) => {
            switch (item.attribute_type) {
              case 'header':
                return (
                  <HeaderText
                    key={uuidv4()}
                    data={{
                      header: item.attribute_key,
                      subheader: JSON.parse(item.attribute_value)[0]
                    }}
                  />
                )
              case 'multipleChoice':
                return (
                  <MultipleChoice
                    key={uuidv4()}
                    onChangeCallback={() => {}}
                    data={{
                      question: item.attribute_key,
                      answers: item.attribute_value,
                      required: item.attribute_is_required
                    }}
                  />
                )
              case 'enum':
                return (
                  <DropdownMaterial
                    key={uuidv4()}
                    onChangeCallback={() => {}}
                    data={{
                      question: item.attribute_key,
                      answers: item.attribute_value,
                      altText: 'Choose one option',
                      required: item.attribute_is_required
                    }}
                  />
                )
              case 'singleChoice':
                return (
                  <SingleChoice
                    key={uuidv4()}
                    onChangeCallback={() => {}}
                    data={{
                      question: item.attribute_key,
                      answers: item.attribute_value,
                      required: item.attribute_is_required
                    }}
                  />
                )
              default:
                return <div />
            }
          })}
          <div className="attribute-page-h2">
            <button
              type="button"
              className="splunk-btn-common splunk-btn-black"
              onClick={() => {}}
              style={{ marginRight: 10 }}
            >
              Skip and Finish Later
            </button>
            <button
              type="button"
              className="splunk-btn-common splunk-btn-magenta"
              onClick={() => {}}
              style={{ marginRight: 10 }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="splunk-btn-common splunk-btn-magenta-solid"
              onClick={() => {}}
              disabled
            >
              Continue
            </button>
          </div>
        </div>
      )}
    </form>
  )
}
